import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1022"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.165 13.399h-.551l-1.47-3.375 2.224-2.982a.807.807 0 0 0 .029-.921l-2.202-4.429a.792.792 0 0 0-1.101-.229.805.805 0 0 0-.228 1.109l1.895 3.958-2.167 2.906a.805.805 0 0 0-.092.803l1.376 3.16H9.286l-1.47-3.375 2.224-2.982a.807.807 0 0 0 .029-.921L7.867 1.692a.792.792 0 0 0-1.101-.229.805.805 0 0 0-.228 1.109L8.433 6.53 6.266 9.436a.805.805 0 0 0-.092.803l1.376 3.16H5.176l-1.47-3.375L5.93 7.042a.807.807 0 0 0 .029-.921L3.757 1.692c-.24-.369-.734-.472-1.101-.229s-.469.74-.228 1.109L4.324 6.53 2.156 9.436a.805.805 0 0 0-.092.803l1.376 3.16H1.829a.798.798 0 0 0-.795.801c.001.442.356.8.795.8h12.336a.798.798 0 0 0 .795-.801c0-.442-.355-.8-.795-.8z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }